import { TransactionMaterial } from "fe-shared-transactions/src/types";
import Joi from "fe-shared/src/helpers/validation";
import { ErrorMessages } from "fe-shared/src/types/common";

import { mapMaterialsToForm } from "./helpers";
import { EditInventoryAdjustmentFormContent } from "./types";

export const errorMessages: ErrorMessages = {
  comment: {
    "string.empty": "validation.commentRequired",
    "string.min": "validation.commentTooShort",
    "string.max": "validation.commentTooLong",
  },
  actions: {
    "array.min": "validation.actionsRequired",
  },
  to: {
    "string.base": "validation.targetRequired",
    "string.empty": "validation.targetRequired",
    "any.invalid": "validation.sameTargetAndSource",
  },
  from: {
    "string.base": "validation.sourceRequired",
    "string.empty": "validation.sourceRequired",
  },
  unitQuantity: {
    "number.base": "validation.amountRequired",
    "number.min": "validation.amountPositive",
    "number.max": "validation.amountMax",
    "number.unsafe": "validation.amountInvalid",
    "any.invalid": "validation.amountNonZero",
  },
};

export const getInitialContent = (
  materials: TransactionMaterial[]
): EditInventoryAdjustmentFormContent => ({
  comment: "",
  materials: mapMaterialsToForm(materials),
});

export const getValidationConfig = () => {
  return Joi.object({
    comment: Joi.string().required(),
    materials: Joi.array().items(
      Joi.object({
        key: Joi.any().required(),
        materialCode: Joi.string().required(),
        materialName: Joi.string().allow(null, ""),
        isOriginal: Joi.boolean(),
        units: Joi.object({
          unitQuantity: Joi.number().max(9999999999.99).disallow(0).required(),
          unit: Joi.string(),
        }),
      })
    ),
  });
};
